import React, { useEffect, useState } from 'react';
import { makeCSS } from '../../utils/makeCSS';
import { Avatar } from './Avatar';
import { Icon } from './Icon';
import { SizeVariants } from '../../theme/themes';
import { Typography } from './Typography';
import mergeRefs from '../../helpers/MergeRefs';
import { isMobile } from 'react-device-detect';
import Truncate from '../utility/Truncate';

/** */

export interface AccountIndicatorProps {
  /**Username for the avatar */
  userInitial?: string;
  /**username that gets displayed */
  username?: string;
  email: string;
  imageUrl?: string;
  onClick?(): void;
  'data-cy'?: string;
  extraButtonProperties?: {
    component?: string | React.ElementType;
    href?: string;
    download?: boolean;
    datatype?: string;
    [key: string]: any;
  };
  showmore?: boolean;
}

const useCSS = makeCSS(({ theme }) => {
  return {
    mobile: {
      '&:hover': {
        background: 'none'
      }
    },
    root: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing[4],
      padding: theme.spacing[3],
      borderRadius: theme.borderRadius.lg,
      background: 'none',
      cursor: 'pointer',
      '&:hover': {
        background: theme.color.overlay.hovered
      }
    },
    selected: {
      background: theme.color.overlay.focused
    },
    info: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing[1],
      width: '100%'
    },
    unfoldIcon: {
      marginLeft: 'auto',
      width: theme.spacing[8]
    }
  };
});

export const AccountIndicator = (props: AccountIndicatorProps) => {
  const {
    userInitial,
    username,
    email,
    imageUrl,
    onClick,
    extraButtonProperties = { buttonRef: null },
    showmore
  } = props;

  const classes = useCSS(props);

  const { buttonRef, fullWidth, ...rest } = extraButtonProperties;

  const [open, setOpen] = useState(false);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    setOpen(!!showmore);
  }, [showmore]);

  const handleHover = () => {
    setHovered(!hovered);
  };

  useEffect;

  return (
    <div
      ref={mergeRefs(buttonRef)}
      className={`${classes.root} ${isMobile ? classes.mobile : ''} ${
        open ? classes.selected : ''
      }`}
      onClick={onClick}
      onMouseEnter={handleHover}
      onMouseLeave={handleHover}
    >
      <Avatar userInitial={userInitial} imageUrl={imageUrl} />
      <span className={`${classes.info}`}>
        <Typography variant="md" weight="body" colorVariant={'01'}>
          <Truncate str={username} />
        </Typography>
        <Typography variant="sm" weight="body" colorVariant={'03'}>
          <Truncate str={email} />
        </Typography>
      </span>

      <span className={`${classes.unfoldIcon}`}>
        {(hovered || open) && (
          <Icon icon={'more'} colorVariant="02" size={SizeVariants.md} />
        )}
      </span>
    </div>
  );
};
